import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import classNames from 'classnames';
import NavIcon from 'Shared/assets/icons/nav.svg';
import styles from './ButtonLink.css';
export const ButtonLink = memo(function ButtonLink({ link: ChildLink, className, to, target, title, isNavLink, isTextFieldLink, outlined, withIcon, children, referrerData, }) {
    return (_jsxs(ChildLink, Object.assign({ className: classNames(className, styles.layout, { [styles.outlined]: outlined }), to: to, target: target, title: title, isNavLink: isNavLink, isTextFieldLink: isTextFieldLink }, (referrerData && { referrerData }), { children: [children, withIcon && _jsx(NavIcon, { "data-testid": "navIcon" }, void 0)] }), void 0));
});
